/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  compactAppliedFilters,
  type CustomFieldFilterMap,
  type LeadCountPreset,
  type TriState,
} from "./userManagementFilterUtils";

const filterFieldDefaults = {
  userId: "",
  isActive: "all" as TriState,
  isDefault: "all" as TriState,
  city: "",
  state: "",
  country: "",
  leadCountPreset: "all" as LeadCountPreset,
  minLeadCount: "",
  maxLeadCount: "",
};

export type BranchListFilterFieldDefaults = typeof filterFieldDefaults;

const initialState = {
  search: "",
  ...filterFieldDefaults,
  cfFilters: {} as CustomFieldFilterMap,
  appliedFilters: {} as Record<string, any>,
};

export type BranchListFilterState = typeof initialState;

const branchListFilterSlice = createSlice({
  name: "branchListFilter",
  initialState,
  reducers: {
    setBranchListSearch(state, action: PayloadAction<string>) {
      state.search = action.payload;
      if (action.payload) state.appliedFilters.search = action.payload;
      else delete state.appliedFilters.search;
    },
    setBranchListFilterField(
      state,
      action: PayloadAction<{ key: keyof BranchListFilterFieldDefaults; value: any }>
    ) {
      (state as any)[action.payload.key] = action.payload.value;
    },
    setBranchListCustomField(
      state,
      action: PayloadAction<{ customInputId: string | number; value: string }>
    ) {
      const key = String(action.payload.customInputId);
      if (!action.payload.value || action.payload.value === "all") {
        delete state.cfFilters[key];
      } else {
        state.cfFilters[key] = action.payload.value;
      }
    },
    applyBranchListFilters(state) {
      state.appliedFilters = {
        ...(state.search ? { search: state.search } : {}),
        ...compactAppliedFilters(state as any, filterFieldDefaults, state.cfFilters),
      };
    },
    clearBranchListFilters() {
      return initialState;
    },
  },
});

export const {
  setBranchListSearch,
  setBranchListFilterField,
  setBranchListCustomField,
  applyBranchListFilters,
  clearBranchListFilters,
} = branchListFilterSlice.actions;

export default branchListFilterSlice.reducer;
